import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoNoCelebracion, TipoNoCelebracionProps } from '../../interfaces/catalogos/TipoNoCelebracionInterface';

export const TipoNoCelebraciones = () => {

    return new Promise<TipoNoCelebracionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoNoCelebracion/', token)
            .then( ({ data } : { data : TipoNoCelebracionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoNoCelebracion = () => {

    return new Promise<TipoNoCelebracionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoNoCelebracion/ObtenerTipoNoCelebraciones', token)
            .then( ({ data } : { data : TipoNoCelebracionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoNoCelebracion = ( params: TipoNoCelebracionProps ) => {

    return new Promise<TipoNoCelebracionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoNoCelebracion/Actualizar', params, token)
            .then( ({ data } : { data : TipoNoCelebracionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoNoCelebracion } );
            });

        }

    });

}

export const AgregarTipoNoCelebracion = ( params: TipoNoCelebracionProps ) => {

    return new Promise<TipoNoCelebracionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoNoCelebracion/Agregar', params, token)
            .then( ({ data } : { data : TipoNoCelebracionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoNoCelebracion } );
            });

        }

    });

}
